// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-form-container {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    /* Match the WixOnboarding page background (.wxo-wrapper) exactly. */
    background: linear-gradient(155deg, #5e1bff 0%, #4516c6 48%, #2c0a63 100%) !important;
    background-color: #5e1bff;
    padding: 20px;
    box-sizing: border-box;
    position: relative;
}

.login-buttons-container {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.page-logo {
    position: absolute;
    top: 16px;
    left: 20px;
    display: inline-flex;
    align-items: center;
    text-decoration: none;
}

.page-logo-img {
    width: 140px;
    height: auto;
}

.login-form {
    background-color: #ffffff;
    padding: 30px;
    padding-top: 20px;
    border-radius: 12px;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 500px;
    box-sizing: border-box;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.login-form:hover {
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
}

/* ── Two-panel auth card: white form (left) + brand visual (right) ──
   Mirrors the Wix onboarding step-0 split. The form is already a white card, so
   inside .login-card it drops its own radius/shadow and becomes the left panel. */
.login-card {
    display: flex;
    width: 100%;
    max-width: 980px;
    min-height: 580px;
    background: #ffffff;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 24px 60px rgba(24, 8, 64, 0.28);
}
.login-card-form {
    flex: 1 1 47%;
    min-width: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 36px 40px;
    overflow-y: auto;
}
.login-card-visual {
    flex: 1 1 53%;
    min-width: 0;
    align-self: stretch;
}
.login-card-form .login-form {
    background: transparent;
    box-shadow: none;
    border-radius: 0;
    padding: 0;
    max-width: 400px;
    transition: none;
}
.login-card-form .login-form:hover {
    box-shadow: none;
}

/* Narrow viewports: drop the visual, center a compact single-column form. */
@media (max-width: 900px) {
    .login-card {
        display: block;
        min-height: 0;
        max-width: 460px;
    }
    .login-card-visual {
        display: none;
    }
    .login-card-form {
        padding: 28px 26px;
        overflow: visible;
    }
}

.form-title {
    font-size: 2rem;
    font-weight: 700;
    margin: 0 0 8px 0;
    color: #111827;
    text-align: left;
}

.form-subtitle {
    margin: 0 0 20px 0;
    color: #6b7280;
    font-size: 0.975rem;
    text-align: left;
}

.google-login {
    width: 100%;
}

.google-login-btn {
    width: 100%;
    padding: 0.4rem;
    border-radius: 10px;
    border: 1px solid #e5e7eb;
    font-size: 1rem;
    font-weight: 600;
    background-color: #ffffff;
    color: #374151;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    cursor: pointer;
    transition: background-color 0.2s ease, border-color 0.2s ease;
    margin-bottom: 0.5rem;
    margin-top: 0.5rem;
}

.google-login-btn:hover {
    background-color: #f9fafb;
    border-color: #d1d5db;
}

.google-logo {
    background-color: transparent;
    height: 22px;
    margin-bottom: 2px;
}

.hr-sep {
    width: 100%;
    display: flex;
    align-items: center;
    margin: 14px 0 16px 0;
    color: #6b7280;
    font-size: 0.85rem;
    font-weight: 700;
}

.hr-sep::before,
.hr-sep::after {
    content: "";
    flex: 1 1;
    border-bottom: 1px solid #e5e7eb;
}

.hr-sep:not(:empty)::before {
    margin-right: 12px;
}

.hr-sep:not(:empty)::after {
    margin-left: 12px;
}

.hr-text {
    white-space: nowrap;
    margin-bottom: 3px;
}

.input-label {
    display: block;
    color: #374151;
    font-size: 0.95rem;
    font-weight: 600;
}

.password-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
    margin-bottom: 8px;
}

.forgot-link {
    color: #5616ea;
    font-weight: 600;
    cursor: pointer;
    font-size: 0.9rem;
}

.forgot-link:hover {
    text-decoration: underline;
}

.login-input {
    display: flex;
    margin-bottom: 14px;
    width: 100%;
}

.login-input input {
    width: 100%;
    padding: 0.9rem 1rem;
    font-size: 1rem;
    border-radius: 10px;
    border: 1px solid #e5e7eb;
    background-color: #ffffff;
    color: #111827;
    transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
}

.login-input input:not(:placeholder-shown) {
    background-color: transparent;
}

input:-webkit-autofill {
  box-shadow: 0 0 0 1000px transparent inset !important;
  -webkit-text-fill-color: #111827 !important;
  caret-color: #111827 !important;
  background-color: transparent !important;
}

.login-input input::placeholder {
    color: #9ca3af;
    font-weight: 400;
}

.login-input input:focus {
    outline: none;
    border-color: #5616ea;
    box-shadow: 0 0 0 3px #5616ea22;
}

.submit-area {
    margin-top: 12px;
    width: 100%;
}

.submit-login {
    width: 100%;
    padding: 0.7rem;
    border-radius: 10px;
    border: none;
    font-size: 1rem;
    font-weight: 700;
    background-color: #5616ea;
    color: #ffffff;
    cursor: pointer;
    transition: background-color 0.2s ease, transform 0.15s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 14px;
}

.submit-login:hover {
    background-color: #4a14d6;
    transform: translateY(-1px);
}

.submit-login:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
}

.login-loader {
    border: 2px solid #ffffff;
    border-top: 2px solid #5616ea;
    border-radius: 50%;
    width: 16px;
    height: 16px;
    animation: spin 1s linear infinite;
    margin-left: 8px;
}

.login-error {
    color: #dc3545;
    margin-top: 0.5rem;
    font-size: 0.95rem;
    font-weight: 600;
    text-align: center;
}

.terms-text {
    margin: 8px 0 14px 0;
    color: #6b7280;
    font-size: 0.9rem;
    text-align: center;
}

.terms-text a {
    color: #111827;
    font-weight: 600;
    text-decoration: underline;
    text-underline-offset: 2px;
}

.signup-row {
    text-align: center;
    color: #6b7280;
    font-size: 0.95rem;
}

.signup-link {
    color: #111827;
    font-weight: 700;
    margin-left: 2px;
    cursor: pointer;
    text-decoration: underline;
    text-underline-offset: 2px;
}

/* Top-right language dropdown — matches the WixOnboarding selector (.wxo-lang*):
   a transparent white trigger over the purple background + a white rounded menu
   with a ticked current option. */
.login-lang {
  position: absolute;
  top: 10px;
  right: 20px;
  z-index: 7;
}

.login-lang-trigger {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border: none;
  border-radius: 10px;
  background: transparent;
  cursor: pointer;
  transition: background 0.15s;
}

.login-lang-trigger:hover {
  background: rgba(255, 255, 255, 0.12);
}

.login-lang-icon {
  width: 18px;
  height: 18px;
  color: #fff;
}

.login-lang-current {
  color: #fff;
  font-weight: 600;
  font-size: 0.95rem;
  letter-spacing: 0.3px;
}

.login-lang-menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  min-width: 200px;
  background: #fff;
  border: 1px solid #efecf8;
  border-radius: 10px;
  box-shadow: 0 18px 44px rgba(24, 8, 64, 0.24);
  padding: 6px;
  display: flex;
  flex-direction: column;
  animation: login-lang-pop 0.16s ease both;
}

@keyframes login-lang-pop {
  from { opacity: 0; transform: scale(0.96) translateY(6px); }
  to   { opacity: 1; transform: scale(1) translateY(0); }
}

.login-lang-option {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 9px 10px;
  border: none;
  background: transparent;
  border-radius: 10px;
  cursor: pointer;
  font-family: inherit;
  font-size: 0.94rem;
  font-weight: 500;
  color: #1b1630;
  text-align: left;
  transition: background 0.12s;
}

.login-lang-option:hover {
  background: #f4f2fb;
}

.login-lang-option.login-lang-sel {
  background: #f3f0ff;
  font-weight: 600;
}

.login-lang-check {
  width: 16px;
  display: inline-flex;
  justify-content: center;
  color: #5616ea;
  font-size: 0.82rem;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

@media (max-width: 480px) {
    .login-form {
        padding: 30px 20px;
    }

    .form-title {
        font-size: 1.75rem;
    }

    .submit-login,
    .google-login-btn {
        font-size: 0.95rem;
        padding: 0.75rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Login.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,oEAAoE;IACpE,qFAAqF;IACrF,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,oBAAoB;IACpB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,yCAAyC;IACzC,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,qDAAqD;AACzD;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;;kFAEkF;AAClF;IACI,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,6CAA6C;AACjD;AACA;IACI,aAAa;IACb,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;;AAEA,4EAA4E;AAC5E;IACI;QACI,cAAc;QACd,aAAa;QACb,gBAAgB;IACpB;IACA;QACI,aAAa;IACjB;IACA;QACI,kBAAkB;QAClB,iBAAiB;IACrB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,8DAA8D;IAC9D,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,SAAO;IACP,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,oFAAoF;AACxF;;AAEA;IACI,6BAA6B;AACjC;;AAEA;EAEE,qDAAqD;EACrD,2CAA2C;EAC3C,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,4DAA4D;IAC5D,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;;kCAEkC;AAClC;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,OAAO,UAAU,EAAE,sCAAsC,EAAE;EAC3D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;;QAEI,kBAAkB;QAClB,gBAAgB;IACpB;AACJ","sourcesContent":[".login-form-container {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    min-height: 100vh;\r\n    /* Match the WixOnboarding page background (.wxo-wrapper) exactly. */\r\n    background: linear-gradient(155deg, #5e1bff 0%, #4516c6 48%, #2c0a63 100%) !important;\r\n    background-color: #5e1bff;\r\n    padding: 20px;\r\n    box-sizing: border-box;\r\n    position: relative;\r\n}\r\n\r\n.login-buttons-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 12px;\r\n}\r\n\r\n.page-logo {\r\n    position: absolute;\r\n    top: 16px;\r\n    left: 20px;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    text-decoration: none;\r\n}\r\n\r\n.page-logo-img {\r\n    width: 140px;\r\n    height: auto;\r\n}\r\n\r\n.login-form {\r\n    background-color: #ffffff;\r\n    padding: 30px;\r\n    padding-top: 20px;\r\n    border-radius: 12px;\r\n    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);\r\n    width: 100%;\r\n    max-width: 500px;\r\n    box-sizing: border-box;\r\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\r\n}\r\n\r\n.login-form:hover {\r\n    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n/* ── Two-panel auth card: white form (left) + brand visual (right) ──\r\n   Mirrors the Wix onboarding step-0 split. The form is already a white card, so\r\n   inside .login-card it drops its own radius/shadow and becomes the left panel. */\r\n.login-card {\r\n    display: flex;\r\n    width: 100%;\r\n    max-width: 980px;\r\n    min-height: 580px;\r\n    background: #ffffff;\r\n    border-radius: 16px;\r\n    overflow: hidden;\r\n    box-shadow: 0 24px 60px rgba(24, 8, 64, 0.28);\r\n}\r\n.login-card-form {\r\n    flex: 1 1 47%;\r\n    min-width: 0;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 36px 40px;\r\n    overflow-y: auto;\r\n}\r\n.login-card-visual {\r\n    flex: 1 1 53%;\r\n    min-width: 0;\r\n    align-self: stretch;\r\n}\r\n.login-card-form .login-form {\r\n    background: transparent;\r\n    box-shadow: none;\r\n    border-radius: 0;\r\n    padding: 0;\r\n    max-width: 400px;\r\n    transition: none;\r\n}\r\n.login-card-form .login-form:hover {\r\n    box-shadow: none;\r\n}\r\n\r\n/* Narrow viewports: drop the visual, center a compact single-column form. */\r\n@media (max-width: 900px) {\r\n    .login-card {\r\n        display: block;\r\n        min-height: 0;\r\n        max-width: 460px;\r\n    }\r\n    .login-card-visual {\r\n        display: none;\r\n    }\r\n    .login-card-form {\r\n        padding: 28px 26px;\r\n        overflow: visible;\r\n    }\r\n}\r\n\r\n.form-title {\r\n    font-size: 2rem;\r\n    font-weight: 700;\r\n    margin: 0 0 8px 0;\r\n    color: #111827;\r\n    text-align: left;\r\n}\r\n\r\n.form-subtitle {\r\n    margin: 0 0 20px 0;\r\n    color: #6b7280;\r\n    font-size: 0.975rem;\r\n    text-align: left;\r\n}\r\n\r\n.google-login {\r\n    width: 100%;\r\n}\r\n\r\n.google-login-btn {\r\n    width: 100%;\r\n    padding: 0.4rem;\r\n    border-radius: 10px;\r\n    border: 1px solid #e5e7eb;\r\n    font-size: 1rem;\r\n    font-weight: 600;\r\n    background-color: #ffffff;\r\n    color: #374151;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 10px;\r\n    cursor: pointer;\r\n    transition: background-color 0.2s ease, border-color 0.2s ease;\r\n    margin-bottom: 0.5rem;\r\n    margin-top: 0.5rem;\r\n}\r\n\r\n.google-login-btn:hover {\r\n    background-color: #f9fafb;\r\n    border-color: #d1d5db;\r\n}\r\n\r\n.google-logo {\r\n    background-color: transparent;\r\n    height: 22px;\r\n    margin-bottom: 2px;\r\n}\r\n\r\n.hr-sep {\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    margin: 14px 0 16px 0;\r\n    color: #6b7280;\r\n    font-size: 0.85rem;\r\n    font-weight: 700;\r\n}\r\n\r\n.hr-sep::before,\r\n.hr-sep::after {\r\n    content: \"\";\r\n    flex: 1;\r\n    border-bottom: 1px solid #e5e7eb;\r\n}\r\n\r\n.hr-sep:not(:empty)::before {\r\n    margin-right: 12px;\r\n}\r\n\r\n.hr-sep:not(:empty)::after {\r\n    margin-left: 12px;\r\n}\r\n\r\n.hr-text {\r\n    white-space: nowrap;\r\n    margin-bottom: 3px;\r\n}\r\n\r\n.input-label {\r\n    display: block;\r\n    color: #374151;\r\n    font-size: 0.95rem;\r\n    font-weight: 600;\r\n}\r\n\r\n.password-row {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    margin-top: 10px;\r\n    margin-bottom: 8px;\r\n}\r\n\r\n.forgot-link {\r\n    color: #5616ea;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    font-size: 0.9rem;\r\n}\r\n\r\n.forgot-link:hover {\r\n    text-decoration: underline;\r\n}\r\n\r\n.login-input {\r\n    display: flex;\r\n    margin-bottom: 14px;\r\n    width: 100%;\r\n}\r\n\r\n.login-input input {\r\n    width: 100%;\r\n    padding: 0.9rem 1rem;\r\n    font-size: 1rem;\r\n    border-radius: 10px;\r\n    border: 1px solid #e5e7eb;\r\n    background-color: #ffffff;\r\n    color: #111827;\r\n    transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;\r\n}\r\n\r\n.login-input input:not(:placeholder-shown) {\r\n    background-color: transparent;\r\n}\r\n\r\ninput:-webkit-autofill {\r\n  -webkit-box-shadow: 0 0 0 1000px transparent inset !important;\r\n  box-shadow: 0 0 0 1000px transparent inset !important;\r\n  -webkit-text-fill-color: #111827 !important;\r\n  caret-color: #111827 !important;\r\n  background-color: transparent !important;\r\n}\r\n\r\n.login-input input::placeholder {\r\n    color: #9ca3af;\r\n    font-weight: 400;\r\n}\r\n\r\n.login-input input:focus {\r\n    outline: none;\r\n    border-color: #5616ea;\r\n    box-shadow: 0 0 0 3px #5616ea22;\r\n}\r\n\r\n.submit-area {\r\n    margin-top: 12px;\r\n    width: 100%;\r\n}\r\n\r\n.submit-login {\r\n    width: 100%;\r\n    padding: 0.7rem;\r\n    border-radius: 10px;\r\n    border: none;\r\n    font-size: 1rem;\r\n    font-weight: 700;\r\n    background-color: #5616ea;\r\n    color: #ffffff;\r\n    cursor: pointer;\r\n    transition: background-color 0.2s ease, transform 0.15s ease;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin-bottom: 14px;\r\n}\r\n\r\n.submit-login:hover {\r\n    background-color: #4a14d6;\r\n    transform: translateY(-1px);\r\n}\r\n\r\n.submit-login:disabled {\r\n    background-color: #6c757d;\r\n    cursor: not-allowed;\r\n}\r\n\r\n.login-loader {\r\n    border: 2px solid #ffffff;\r\n    border-top: 2px solid #5616ea;\r\n    border-radius: 50%;\r\n    width: 16px;\r\n    height: 16px;\r\n    animation: spin 1s linear infinite;\r\n    margin-left: 8px;\r\n}\r\n\r\n.login-error {\r\n    color: #dc3545;\r\n    margin-top: 0.5rem;\r\n    font-size: 0.95rem;\r\n    font-weight: 600;\r\n    text-align: center;\r\n}\r\n\r\n.terms-text {\r\n    margin: 8px 0 14px 0;\r\n    color: #6b7280;\r\n    font-size: 0.9rem;\r\n    text-align: center;\r\n}\r\n\r\n.terms-text a {\r\n    color: #111827;\r\n    font-weight: 600;\r\n    text-decoration: underline;\r\n    text-underline-offset: 2px;\r\n}\r\n\r\n.signup-row {\r\n    text-align: center;\r\n    color: #6b7280;\r\n    font-size: 0.95rem;\r\n}\r\n\r\n.signup-link {\r\n    color: #111827;\r\n    font-weight: 700;\r\n    margin-left: 2px;\r\n    cursor: pointer;\r\n    text-decoration: underline;\r\n    text-underline-offset: 2px;\r\n}\r\n\r\n/* Top-right language dropdown — matches the WixOnboarding selector (.wxo-lang*):\r\n   a transparent white trigger over the purple background + a white rounded menu\r\n   with a ticked current option. */\r\n.login-lang {\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 20px;\r\n  z-index: 7;\r\n}\r\n\r\n.login-lang-trigger {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 6px 12px;\r\n  border: none;\r\n  border-radius: 10px;\r\n  background: transparent;\r\n  cursor: pointer;\r\n  transition: background 0.15s;\r\n}\r\n\r\n.login-lang-trigger:hover {\r\n  background: rgba(255, 255, 255, 0.12);\r\n}\r\n\r\n.login-lang-icon {\r\n  width: 18px;\r\n  height: 18px;\r\n  color: #fff;\r\n}\r\n\r\n.login-lang-current {\r\n  color: #fff;\r\n  font-weight: 600;\r\n  font-size: 0.95rem;\r\n  letter-spacing: 0.3px;\r\n}\r\n\r\n.login-lang-menu {\r\n  position: absolute;\r\n  top: calc(100% + 8px);\r\n  right: 0;\r\n  min-width: 200px;\r\n  background: #fff;\r\n  border: 1px solid #efecf8;\r\n  border-radius: 10px;\r\n  box-shadow: 0 18px 44px rgba(24, 8, 64, 0.24);\r\n  padding: 6px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  animation: login-lang-pop 0.16s ease both;\r\n}\r\n\r\n@keyframes login-lang-pop {\r\n  from { opacity: 0; transform: scale(0.96) translateY(6px); }\r\n  to   { opacity: 1; transform: scale(1) translateY(0); }\r\n}\r\n\r\n.login-lang-option {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  width: 100%;\r\n  padding: 9px 10px;\r\n  border: none;\r\n  background: transparent;\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  font-family: inherit;\r\n  font-size: 0.94rem;\r\n  font-weight: 500;\r\n  color: #1b1630;\r\n  text-align: left;\r\n  transition: background 0.12s;\r\n}\r\n\r\n.login-lang-option:hover {\r\n  background: #f4f2fb;\r\n}\r\n\r\n.login-lang-option.login-lang-sel {\r\n  background: #f3f0ff;\r\n  font-weight: 600;\r\n}\r\n\r\n.login-lang-check {\r\n  width: 16px;\r\n  display: inline-flex;\r\n  justify-content: center;\r\n  color: #5616ea;\r\n  font-size: 0.82rem;\r\n}\r\n\r\n@keyframes spin {\r\n    0% { transform: rotate(0deg); }\r\n    100% { transform: rotate(360deg); }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    .login-form {\r\n        padding: 30px 20px;\r\n    }\r\n\r\n    .form-title {\r\n        font-size: 1.75rem;\r\n    }\r\n\r\n    .submit-login,\r\n    .google-login-btn {\r\n        font-size: 0.95rem;\r\n        padding: 0.75rem;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
